import { QUERY_KEYS } from "@forwardflow/helpers/utils/constants"
import CampaignService from "@forwardflow/services/CampaignService"
import useSWR from "swr"
import { gated } from "@forwardflow/utils/sandbox"

export const useGetVoices = () => {
   return useSWR(
      gated([QUERY_KEYS.GET_VOICES]),
      () => CampaignService.getVoices()
   )
}
